import { ICellAdapter } from "./ICellAdapter";
import { ColumnDefinition } from "../model/ColumnDefinition";

// Get Long + BigNumber from CubiqTS for instanceof to work with ConcreteEncodable
import * as CubiqTS from "shared/cubiq-model-multi-asset";

// Also handle direct use of libraries
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { Long } from "shared/cubiq-model-multi-asset";

// String types that are sortable as an Int32 in C++ module
export class NumericAdapter implements ICellAdapter {
  constructor() {}

  adapt(column: ColumnDefinition, row: any, ...modelObjects: Array<any>): void {
    // Nesting within modelObject should be applied in a more specific adapter

    row[column.data] = this.retrieveData(this.getModelObject(modelObjects), column.data);
    row[column.sortKey] = this.retrieveSort(this.getModelObject(modelObjects), column.data);
    row[column.filterKey] = this.retrieveFilter(this.getModelObject(modelObjects), column.data);

    if (column.hasSearchKey) {
      row[column.searchKey] = this.retrieveSearch(this.getModelObject(modelObjects), column.data);
    }
  }

  protected getModelObject(modelObjects: Array<any>) {
    return modelObjects[0];
  }

  retrieveData(order: any, columnProperty: string): string {
    if (order && typeof order[columnProperty] === "string") {
      return order[columnProperty];
    } else if (order && typeof order[columnProperty] === "number") {
      return order[columnProperty] + "";
    } else if (
      order &&
      order[columnProperty] &&
      order[columnProperty] instanceof CubiqTS.BigNumber
    ) {
      return order[columnProperty].toString();
    } else if (order && order[columnProperty] && order[columnProperty] instanceof CubiqTS.Long) {
      return order[columnProperty].toString();
    } else if (order && order[columnProperty] && order[columnProperty] instanceof BigNumber) {
      return order[columnProperty].toString();
    } else if (order && order[columnProperty] && order[columnProperty] instanceof Long) {
      return order[columnProperty].toString();
    } else {
      console.debug("Invalid model adaptation[" + columnProperty + "]");
      console.debug(
        "order= ",
        order,
        " order[columnProperty]=",
        order[columnProperty],
        "comaprison=",
        order[columnProperty] instanceof BigNumber,
      );
    }
    return "";
  }

  retrieveSort(order: any, columnProperty: string): any {
    if (order && typeof order[columnProperty] === "string") {
      return Number(order[columnProperty]);
    } else if (order && typeof order[columnProperty] === "number") {
      return order[columnProperty];
    } else if (order && order[columnProperty] && order[columnProperty] instanceof BigNumber) {
      return order[columnProperty].toString();
    } else if (order && order[columnProperty] && CubiqTS.Long.isLong(order[columnProperty])) {
      return (order[columnProperty] as CubiqTS.Long).getLowBits();
    } else {
      console.debug("Invalid model adaptation[" + columnProperty + "]");
    }
    return NaN;
  }

  retrieveSearch(order: any, columnProperty: string): any {
    // should really need to be overriden, just match existing contract as string
    return this.retrieveSort(order, columnProperty).toString();
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return this.retrieveSort(order, columnProperty);
  }
}
